import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'csat/evaluation/:customerHash',
    loadChildren: () =>
      import(
        './features/feature-csat-evaluation/feature-csat-evaluation.module'
      ).then((x) => x.FeatureCsatEvaluationModule),
  },
  {
    path: '',
    loadChildren: () =>
      import('./features/feature-layout/feature-layout.module').then(
        (x) => x.FeatureLayoutModule
      ),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {}),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
